module.exports = __webpack_public_path__ + "img/gallery.dcd610be.gif";